<template>
    <div>
        <div class="content-box">
            <p style="margin-bottom:10px;padding:6px 10px;background:#f5f7fa;border-left:3px solid #409EFF;font-size:13px;">
                排单定版制作部门：<span style="color:#409EFF;">{{ schedulingGroupName || '-' }}</span>
            </p>
            <div v-if="tagsActive == 2">
                <el-table :data="detail_cannot_redo_assign"
                          :header-cell-style="{ background: '#f8f8f8', color: '#333' }"
                          style="width: 100%"
                          size="mini"
                          ref="table"
                >
                    <el-table-column
                        prop="upload_num"
                        label="已上传素材数量"
                        width="'33%'">
                        <template slot-scope="scope">
                            <span>{{scope.row.upload_num}}</span>
<!--                            <p>lock:{{scope.row.lock_num}}</p>-->

                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="producer"
                        label="制作人"
                        width="'34%'">
                    </el-table-column>
                    <el-table-column
                        prop="finish_time"
                        label="制作完成时间"
                        width="'33%'">
                    </el-table-column>
                </el-table>
            </div>
            <p>剩余可指派数量 / {{ tagsActive == 1 ? '需求数量' : '可重新指派数量' }}：{{rows.can_redo_assign_num - surplusNum > 0 ? rows.can_redo_assign_num - surplusNum : 0 }} / {{tagsActive == 1 ? rows.material_num : rows.can_redo_assign_num}}
                <span v-if="rows.can_redo_assign_num - surplusNum < 0" style="color:red;padding-left: 8px;">{{errMsg}}</span>
            </p>
            <el-table
                size="mini"
                :data="detail"
                border
                :header-cell-style="{background:'#e8eaec',color:'#333'}"
                :row-class-name="tableRowClassName"
            >
                <el-table-column
                    prop="action"
                    label="操作"
                    align="center"
                    width="120"
                >
                    <template slot-scope="scope">
                        <span @click="addRow(scope.$index)" class="el-icon-circle-plus pointer text-color-primary font16px ml2 mr2" title="添加一行"></span>
                        <span @click="copyRow(scope.$index)" class="el-icon-document-copy pointer font16px ml2 mr2" title="复制"></span>
                        <el-popconfirm
                            title="您确定要删除吗？"
                            confirm-button-text="删除"
                            confirm-button-type="danger"
                            @confirm="deleteRow(scope.$index)"
                        >
                            <span slot="reference" class="el-icon-remove pointer text-color-error font16px ml2 mr2" title="删除"></span>
                        </el-popconfirm>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="size"
                    label="制作素材数"
                    align="center">
                    <template slot="header" slot-scope="scope">
                        <span><i style="color:red;padding-right: 3px;">*</i>制作素材数</span>
                    </template>
                    <template slot-scope="scope">
                        <el-input class="ys-de-input" :value="scope.row.num" placeholder="请输入" @input="(val)=>changeNum(val,scope.$index)"></el-input>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="material_format"
                    label="选择制作人"
                    align="center"
                    width="300">
                    <template slot="header" slot-scope="scope">
                        <span><i style="color:red;padding-right: 3px;">*</i>选择制作人</span>
                    </template>
                    <template slot-scope="scope">
                        <JtCascader
                            popper-class="cascader-list-height-360"
                            :value="scope.row.producer_uids"
                            :options="producer_options"
                            placeholder="请选择"
                            clearable
                            filterable
                            ref="editCascader"
                            :props="{ multiple: true, emitPath:false }"
                            @change="(val)=>changeCascader(val,scope.$index)"
                            :style="{width: '100%'}"
                        ></JtCascader>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="finish_time"
                    label="制作完成日期"
                    align="center">
                    <template slot="header" slot-scope="scope">
                        <span><i style="color:red;padding-right: 3px;">*</i>制作完成日期</span>
                    </template>
                    <template slot-scope="scope">
                        <el-date-picker type="date" placeholder="选择制作完成日期"
                                        v-model="scope.row.finish_time"
                                        value-format="yyyy-MM-dd" clearable
                                        :picker-options="pickerOptions"
                                        style="width: 100%;" class="ys-de-input"></el-date-picker>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <p class="dialog-footer tac mt20">
            <el-button type="default" @click="hideModal" class="action-btn mr20">取消</el-button>
            <el-button type="primary" @click="submitModal" :loading="formLoading" class="action-btn ml20">确认</el-button>
        </p>
    </div>
</template>

<!-- 指派 单独指派-->
<script>
import {JtCascader } from '@/components/Ele'
import {cloneDeep} from 'lodash'
import dayjs from 'dayjs';
export default {
    name: "assignInfo_withdrawModal",
    props:['rows','producer_options', 'tagsActive', 'cbs', 'schedulingGroupName'],
    components:{
        JtCascader
    },
    data(){
        return {
            formLoading:false,
            detail:[],  //可指派
            rules:{

            },
            some_list:[],
            baseConfig:{
                num: null,
                producer_uids: null,
                finish_time: null
            },
            surplusNum:0,  //剩余数量
            errMsg:'任务的制作素材数不可大于需求数量',
            pickerOptions:{
                disabledDate(time) {
                    return time.getTime() < (Date.now()-(24 * 60 * 60 * 1000));
                },
            },
            detail_cannot_redo_assign:[], // 已上传
        }
    },
    mounted(){

        if(this.tagsActive == 2) {
            let cloneDeep_can_list = cloneDeep(this.rows.detail_assign)
            this.detail_cannot_redo_assign = cloneDeep_can_list.filter(item=>Number(item.upload_num) > 0)
            this.detail = cloneDeep_can_list.filter(item=>{
                let res_lock_num = item.lock_num ? item.lock_num : 0
                if(Number(item.num) - Number(res_lock_num) > 0){
                    return true
                }else{
                    return false
                }

            }).map((item)=>{
                let res_num = Number(item.num) - Number(item.lock_num)
                return {...item, num: res_num, lock_num: 0, upload_num: 0, detail_assign_id: ''}
            })

        }else{
            let cloneDeep_list = cloneDeep(this.rows.detail_assign)
            this.baseConfig.num = this.rows.can_redo_assign_num - this.surplusNum > 0 ?  this.rows.can_redo_assign_num - this.surplusNum : ''
            this.baseConfig.finish_time = this.rows.expected_end_time
            this.detail = Array.isArray(cloneDeep_list) && cloneDeep_list.length !== 0 ? cloneDeep_list : [this.baseConfig]
        }
    },
    watch:{
        'detail': {
            handler(n) {
                this.surplusNum = n.reduce((prev, cur)=>{
                    return Number(cur.num) + Number(prev)
                }, 0)
            },
            deep: true,
            immediate: true
        }
    },
    methods:{
        addRow(index){
            let length = this.rows.can_redo_assign_num;
            if(this.surplusNum > length){
                return this.$message.error(this.errMsg);
            }
            this.detail.splice(index+1,0,{
                num: null,
                producer_uids: null,
                finish_time: null,
                detail_assign_id: '',
                lock_num: 0
            })
        },
        copyRow(index){
            let length = this.rows.can_redo_assign_num;
            if(this.surplusNum > length){
                return this.$message.error(this.errMsg);
            }
            let data = {...this.detail[index], detail_assign_id: ''};
            this.detail.splice(index+1,0,data)
        },
        deleteRow(index){
            if(this.detail.length<=1){
                return this.$message.error('不能再删了……');
            }
            this.detail.splice(index,1);
        },
        changeNum(val,index) {
            const newValue = val.replace(/[^\d]/g, '');
            if (/^[1-9]\d*$/.test(newValue)) {
                this.detail[index].num = Number(newValue);
            } else {
                this.detail[index].num = '';
            }
        },
        changeCascader(val,index) {
            this.detail[index].producer_uids = val;
            let all_name = this.modifyIdsToValues(this.producer_options, val)
            this.detail[index].producer = all_name.join(',')
        },
        modifyIdsToValues(arr, selectArr, resArr=[]) {
            arr.forEach(obj => {
                const newObj = { ...obj };
                if (newObj.children && newObj.children.length > 0) {
                    newObj.children = this.modifyIdsToValues(newObj.children, selectArr, resArr);
                }
                if (selectArr.includes(obj.value)) {
                    resArr.push(newObj.label)
                }
            });
            return resArr
        },
        changeDate(val,index) {
            this.detail[index].finish_time = val;
        },
        tableRowClassName({row, rowIndex}) {
            if(this.some_list.includes(rowIndex)) {
                return 'warning-row';
            }
            return  ''
        },
        /**
         * 数组对象 指定属性是否重复
         * true 通过 false 有相同
         * */
        compareArrays(arr) {
            let seenCombinations = new Set();

            for (let obj of arr) {
                let combination = obj.finish_time + '-' + obj.producer_uids.join(',');

                if (seenCombinations.has(combination)) {
                    return false;
                } else {
                    seenCombinations.add(combination);
                }
            }

            return true;
        },
        /**
         * 数组对象 指定属性是否重复 收集重复的数组
         *
         * */
        findDuplicateArrays(arr) {
            let seenCombinations = new Map();
            let duplicates = [];

            arr.forEach((obj, index) => {
                let combination = obj.finish_time + '-' + obj.producer_uids.join(',');

                if (seenCombinations.has(combination)) {
                    duplicates.push({
                        index: index,
                        indices: [seenCombinations.get(combination)]
                    });
                } else {
                    seenCombinations.set(combination, index);
                }
            });

            return duplicates;
        },
        submitModal(){
            let length = this.rows.can_redo_assign_num;
            if(this.surplusNum > length){
                return this.$message.error(this.errMsg);
            }
            let noNull = this.detail.some(item=>(item.num === '' || item.num === undefined || !item.finish_time || !item.producer_uids || item.producer_uids.length === 0 ))
            if(noNull) {
                return this.$message.error('所有项均为必填，不可为空。');
            }
            if(this.detail.length === 0) {
                return this.$message.error('没有可指派的任务。');
            }

            const today = dayjs().subtract(1, 'day');
            let isBeforeData = this.detail.some(item=>dayjs(item.finish_time).isBefore(today))
            if(isBeforeData) {
                return this.$message.error('制作完成日期不可早于今天');
            }
            let noSome = this.findDuplicateArrays(this.detail) //true 通过 false 有相同
            this.some_list = noSome.map(item=>item.index)
            if(noSome.length != 0) {
                return this.$message.error('制作人与制作日期不可重复');
            }


            let cloneDeepList = this.detail.map(item=>({upload_num:0 , ...item}))
            let res_detail = cloneDeep(cloneDeepList)
            if(this.tagsActive == 2) {
                // 处理 已上传 剩余上传 合并


                // const result = this.findDuplicateSomeArrays(this.multipleSelection, combination_name)
                // console.log('=----', result)
                // this.detailID = result.map(item=>item.id).join(',')
                // 不同的已上传
                let cannot_redo_assign_no_equl = this.detail_cannot_redo_assign.filter(item=>{
                    let find_index = res_detail.findIndex(item_c=>item_c.producer_uids.join(',') == item.producer_uids.join(',') && item_c.finish_time == item.finish_time)
                    if(find_index != -1){
                        return false
                    }else{
                        return true
                    }
                })


                let new_arr = []


                if(cannot_redo_assign_no_equl.length != 0) {
                    let res_cannot_redo_assign_no_equl = cannot_redo_assign_no_equl.map(item=>{
                        let select_num = Number(item.lock_num)
                        // if(Number(item.upload_num) >= Number(item.prev_cache_num)) {
                        //     select_num = Number(item.prev_cache_num)
                        // }else {
                        //     select_num = Number(item.upload_num)
                        // }
                        item.num = select_num
                        return {...item}
                    })


                    new_arr.push(...res_cannot_redo_assign_no_equl)
                }

                res_detail.forEach(item=>{
                    let find_index = this.detail_cannot_redo_assign.findIndex(item_c=>item_c.producer_uids.join(',') == item.producer_uids.join(',') && item_c.finish_time == item.finish_time)
                    if(find_index != -1){
                        let select_num = Number(item.num) + Number(this.detail_cannot_redo_assign[find_index].lock_num)

                        // let select_num = ''
                        // if(Number(this.detail_cannot_redo_assign[find_index].upload_num) >= Number(this.detail_cannot_redo_assign[find_index].prev_cache_num)) {
                        //     select_num = Number(this.detail_cannot_redo_assign[find_index].prev_cache_num)
                        // }else {
                        //     select_num = Number(this.detail_cannot_redo_assign[find_index].upload_num)
                        // }

                        item.num = Number(select_num)
                        item.lock_num = Number(this.detail_cannot_redo_assign[find_index].lock_num)
                        item.detail_assign_id = this.detail_cannot_redo_assign[find_index].detail_assign_id
                        item.upload_num = this.detail_cannot_redo_assign[find_index].upload_num
                    }
                    new_arr.push(item)
                })


                let res_upload_num = res_detail.map(item => ({...item, upload_num: 0}))
                this.cbs.onSubmit([new_arr, res_upload_num])

            } else {
                this.cbs.onSubmit([res_detail])
            }

        },
        hideModal() {
            this.$emit('close');
        },
    }
}
</script>

<style scoped lang="scss">
.content-box {
    max-height: calc(100vh - 300px);
    overflow-y: auto;

    ::v-deep.el-table .warning-row {
        background: oldlace;
    }

    ::v-deep.ys-de-input.el-input--small .el-input__inner {
        height: 34px;
        line-height: 34px;
    }
}
</style>
<style lang="scss">
.el-cascader-filter-name {
    .el-cascader__tags {
        align-items: center;
        flex-wrap: nowrap;
    }

    .el-tag--info {
        &:first-child {
            span {
                display: inline-block;
                max-width: 60px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }
    }

    .el-cascader__search-input {
        min-width: 20px;
        font-size: 12px;
    }
}
</style>
